import { ComboBox } from "@progress/kendo-react-dropdowns";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { BASE_URL } from "../../../constant";
import Loader from "../../Loader";
import BtnLoader from "../../BtnLoader";
import { useTranslation } from "react-i18next";

const DeviceImportPopup = ({
  setPopup,
  setDetails,
  details,
  loadDeviceSensors,
  authCtx,
  darkMode,
}) => {
  const { t } = useTranslation();
  const [deviceTypes, setDeviceTypes] = useState([]);
  const [deviceType, setDeviceType] = useState();
  const [loading, setLoading] = useState(false);
  const [dataLoader, setDataLoader] = useState(false);
  const [devices, setDevices] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);

  const loadData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/Lookup/GetAllDeviceTypes`);
      setDeviceTypes(res.data);
    } catch (err) {
      if (err.response?.status === 400) console.log(err.response.data);
      // else toast.error("An error occured");
    }
  };

  const loadDevices = async (deviceTypeId) => {
    setDataLoader(true);
    try {
      const companyId = authCtx.profile?.companyId;
      const res = await axios.get(
        `${BASE_URL}/Lookup/GetDevicesStandaredSensors?deviceTypeId=${deviceTypeId}&companyId=${companyId}&userRole=${authCtx.profile.role}`
      );
      setDevices(
        res.data.map((d) => {
          const isSelected = selectedValues.some(
            (s) =>
              s.device.id === d.deviceId && s.deviceType.id === deviceTypeId
          );

          return {
            ...d,
            selected: isSelected,
          };
        })
      );
    } catch (err) {
      if (err.response?.status === 400) console.log(err.response.data);
      // else toast.error("An error occured");
    }
    setDataLoader(false);
  };

  const handleDeviceClick = (p) => {
    setDevices((pre) =>
      pre.map((d) => (d.deviceId === p.deviceId ? { ...d, selected: true } : d))
    );
    const updatedData = {
      device: {
        id: p.deviceId,
        name: p.name,
        interval: p.interval,
      },
      deviceType: {
        id: deviceType.id,
        name: deviceType.name,
      },
      standeredSensors: p.sensors.map((s) => ({
        ...s,
        deviceId: p.deviceId,
        deviceTypeId: deviceType.id,
        default: true,
      })),
    };

    setSelectedValues((pre) => [
      ...pre.filter((s) => s.device.id !== p.deviceId),
      {
        ...updatedData,
        alarms: p.alarms
          ? p.alarms
              .filter((a) =>
                updatedData.standeredSensors.some(
                  (ss) => ss.id === a.parameterId
                )
              )
              .map((a) => ({
                ...a,
                deviceId: p.deviceId,
              }))
          : [],
      },
    ]);
  };

  const handleDeviceTypeChange = (e) => {
    setDevices([]);
    setDeviceType(e.target.value);
    loadDevices(e.value.id);
  };

  const findDevice = (id) => {
    const value = selectedValues.find((x) => x.device.id === id);
    return value;
  };
  const onImport = () => {
    setLoading(true);
    const selectedParams = selectedValues
      .flatMap((sv) => sv.standeredSensors)
      .filter(
        (s) =>
          !details.parameters.some(
            (p) => p.id === s.id && p.parameterId === s.parameterId
          )
      );
    const selectedAlarms = selectedValues
      .flatMap((sv) => sv.alarms)
      .filter((s) => s !== undefined);

    const updatedData = {
      ...details,
      devices: selectedValues.map((sv) => ({
        device: sv.device,
        deviceType: sv.deviceType,
      })),
      parameters: [
        ...details.parameters,
        ...selectedParams.map((sp) => ({
          ...sp,
          parameterId: findDevice(sp.deviceId).device.name + "-" + sp.sensorId,
          name: findDevice(sp.deviceId).device.name + " " + sp.name,
          sensorName: sp.name,
        })),
      ],
      alarms: [
        ...details.alarms,
        ...selectedAlarms.filter(
          (s) =>
            !details.alarms.some(
              (p) =>
                p.parameterId === s.parameterId && p.deviceId === s.deviceId
            )
        ),
      ],
    };
    setDetails(updatedData);
    loadDeviceSensors(updatedData);
    setLoading(false);
    setPopup();
  };

  useEffect(() => {
    loadData();
    const selectedParams = details.devices.map((d) => ({
      ...d,
      standeredSensors: details.parameters.filter(
        (p) =>
          p.default &&
          p.deviceId === d.device.id &&
          p.deviceTypeId === d.deviceType.id
      ),
    }));
    setSelectedValues(selectedParams);
  }, []);

  return (
    <div className="relative flex flex-col dark:text-white text-black px-5 pt-5 pb-3 dark:bg-neutral-900 bg-lightModePopup w-[60vw] h-[83vh] rounded-md">
      <div className="flex justify-between items-start pb-5">
        <div>{t("masters.headerTexts.assetListCardConfig")}</div>
        <div>
          <button type="button" onClick={() => setPopup()}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
      <div className="flex gap-8 text-xs font-medium">
        <div className="flex gap-4 dark:text-gray-100 text-black mt-5">
          <label className="mt-2 w-24">{t("masters.fields.deviceType")}</label>
          <div className={`${darkMode ? "darkCombo" : "lightCombo"}`}>
            <ComboBox
              data={deviceTypes}
              dataItemKey="id"
              textField="name"
              name="name"
              placeholder={t("masters.fields.deviceType")}
              suggest={true}
              clearButton={false}
              className="block placeholder:text-white border-gray-700 rounded-lg mb-4 bg-[#363945] text-white font-medium px-5  h-9"
              onChange={handleDeviceTypeChange}
              // value={deviceType}
              // disabled={assetData.length < 0}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col items-start mt-8">
        {t("homeConfigPopup.availableValues")}
      </div>
      <div className=" overflow-y-auto h-44 mt-1">
        <div className="grid grid-cols-3 gap-3 mb-4 mt-1 px-3">
          {dataLoader && <Loader />}
          {devices
            .sort((x) => x.name)
            .map((p) => (
              <button
                type="button"
                key={p.id}
                className={`flex justify-center w-full h-9 rounded-lg items-center disabled:opacity-50`}
                onClick={() => handleDeviceClick(p)}
              >
                <div
                  className={`flex justify-start w-full py-2 px-8 rounded-lg gap-2 items-center ${
                    p.selected ? "bg-blue-500" : "dark:bg-gray-900 bg-lightModePopupBtn hover:bg-cyan-600"
                  }`}
                >
                  <img src="Sensorlogo.svg" alt="sensorLogo" className="w-6 " />
                  <div className="font-normal text-xs">{p?.name}</div>
                </div>
              </button>
            ))}
        </div>
      </div>
      <div className="flex flex-col items-start mt-8 mb-4">
        {t("homeConfigPopup.selectedValues")}
      </div>
      <div className="grid grid-cols-3 gap-3 mb-4 px-3 h-28 overflow-y-scroll pb-8">
        {selectedValues?.map((p) => (
          <div className="flex justify-start gap-2 bg-blue-500 w-full h-9 py-2 rounded-lg items-center pl-5 ">
            <img src="Sensorlogo.svg" alt="sensorLogo" className="w-6 " />
            <div className="flex flex-col w-full font-normal">
              <span className="w-3/5 text-start text-xs flex flex-col">
                {p?.device.name}
              </span>
              <span className="w-3/5 text-start flex flex-col text-xxs text-gray-200">
                {p.deviceType.name}
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="flex absolute bottom-0 py-3 mb-1 right-10 justify-end gap-2 w-full">
        <button
          type="button"
          className=" bg-white text-black h-8 rounded-4xl text-center w-24"
          onClick={() => setPopup(false)}
        >
          {t("button.cancel")}
        </button>
        <button
          type="button"
          className=" bg-indigo-700 flex justify-center items-center text-sm rounded-4xl w-20 h-8 disabled:opacity-40"
          onClick={onImport}
          disabled={selectedValues.length === 0 || loading}
        >
          {loading.formLoading && <BtnLoader />}
          {t("button.save")}
        </button>
      </div>
    </div>
  );
};

export default DeviceImportPopup;
